export const llmList = [
    "gpt-4.1",
    "gpt-4.1-mini",
    "gpt-4.1-nano",
    "gpt-4o",
    "gpt-4o-2024-05-13",
    "gpt-4o-2024-08-06",
    "gpt-4o-2024-11-20",
    "gpt-4o-mini",
    "o1-mini",
    "o1-preview",
    "o3-mini",
    "o4-mini",
    "gpt-5",
    "gpt-5-mini",
    "gpt-5-nano",
    "gpt-5.1",
    "gpt-5.2",
    "gpt-5.4",
    "gpt-5.4-mini",
    "gpt-5.4-nano",
    "gpt-5.4-2026-03-05",
    "gpt-5.6-sol",
    "gpt-5.6-terra",
    "gpt-5.6-luna",
    "gpt-6-astra",
    "gpt-6-sol",
    "gpt-6-luna",
    "gpt-6.1-sol",
]

// These models reject reasoning_effort 'none' and 'minimal'; 'low' is the lowest accepted value.
export const lowReasoningEffortFloorLlms = [
    "gpt-6.1",
]

export const gptUsageLimit = {
  'gpt-4.1':32,
  'gpt-4.1-mini':32,
  'gpt-4.1-nano':32,
  'gpt-4': 8,
  'gpt-4-32k': 32,
  'gpt-4-turbo': 4,
  'gpt-4o': 128,
  'gpt-4o-2024-05-13': 128,
  'gpt-4o-2024-08-06': 128,
  'gpt-4o-2024-11-20': 128,
  "gpt-4o-mini": 128,
  "o1-mini": 128,
  "o3-mini": 200,
  "o4-mini": 200,
  "o1-preview": 128,
  'gpt-3.5-turbo': 4,
  'gpt-3.5-turbo-16k': 16,
  "gpt-5": 128,
  "gpt-5-mini": 128,
  "gpt-5-nano": 128,
  "gpt-5.1": 128,
  "gpt-5.2": 128,
  "gpt-5.4": 128,
  "gpt-5.4-mini": 128,
  "gpt-5.4-nano": 128,
  "gpt-5.4-2026-03-05": 128,
  "gpt-5.6-sol": 128,
  "gpt-5.6-terra": 128,
  "gpt-5.6-luna": 128,
  "gpt-6-astra": 128,
  "gpt-6-sol": 128,
  "gpt-6-luna": 128,
  "gpt-6.1-sol": 128,
}